import React, { useMemo, useState } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';


import { useAuth } from '../../../shared/AuthContext';

const Component = () => {
  const [searchParams] = useSearchParams();
  const initialToken = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const { establishSession, isAuthenticated, loadingSession } = useAuth();
  const [form, setForm] = useState({
    token: initialToken,
    fullName: '',
    password: '',
    confirmPassword: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  if (!loadingSession && isAuthenticated) {
    return <Navigate replace to="/dashboard" />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Password confirmation does not match.');
      return;
    }
    setSaving(true);
    try {

      const Factory = require( '../../../records/auth' );

      const session = await Factory.acceptInvite({
        token: form.token.trim(),
        fullName: form.fullName.trim(),
        password: form.password,
      });
      establishSession(session);
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Unable to accept invite.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="auth-shell">
      <form className="card auth-card stack" onSubmit={handleSubmit}>
        <div className="stack-sm">
          <h1 className="page-title">Accept invite</h1>
          <p className="page-subtitle">Set your profile and password to activate your account.</p>
        </div>

        {error ? <p className="error-text">{error}</p> : null}

        <label>
          Invite token
          <input
            value={form.token}
            onChange={(event) => setForm((prev) => ({ ...prev, token: event.target.value }))}
            required
          />
        </label>
        <label>
          Full name
          <input
            value={form.fullName}
            onChange={(event) => setForm((prev) => ({ ...prev, fullName: event.target.value }))}
          />
        </label>
        <label>
          Password
          <input
            autoComplete="new-password"
            type="password"
            value={form.password}
            onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
            required
          />
        </label>
        <label>
          Confirm password
          <input
            autoComplete="new-password"
            type="password"
            value={form.confirmPassword}
            onChange={(event) => setForm((prev) => ({ ...prev, confirmPassword: event.target.value }))}
            required
          />
        </label>

        <button className="button-primary" disabled={saving} type="submit">
          {saving ? 'Activating...' : 'Activate account'}
        </button>

        <Link className="inline-link" to="/login">Back to sign in</Link>
      </form>
    </div>
  );
};

export default Component;
